/* Golf Depot - Main JS */

document.addEventListener('DOMContentLoaded', function () {

  // ── Header scroll shadow ─────────────────────────────────
  const header = document.querySelector('.gd-header');
  if (header) {
    let headerTicking = false;
    window.addEventListener('scroll', () => {
      if (headerTicking) return;
      headerTicking = true;
      requestAnimationFrame(() => {
        header.classList.toggle('scrolled', window.scrollY > 20);
        headerTicking = false;
      });
    }, { passive: true });
  }

  // ── Mobile nav ───────────────────────────────────────────
  const toggle = document.getElementById('gd-menu-toggle');
  const mobileNav = document.getElementById('gd-mobile-nav');
  const mobileClose = document.getElementById('gd-mobile-close');

  const mainContent = document.getElementById('main-content');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      mobileNav.classList.add('open');
      toggle.setAttribute('aria-expanded', 'true');
      if (mainContent) mainContent.setAttribute('inert', '');
      mobileClose.focus();
    });
  }
  if (mobileNav) {
    mobileNav.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-open]');
      if (opener) {
        const panel = mobileNav.querySelector('[data-panel="' + opener.getAttribute('data-open') + '"]');
        if (panel) panel.classList.add('open');
        return;
      }
      if (e.target.closest('[data-back]')) {
        const cur = e.target.closest('.gd-mnav__panel');
        if (cur) cur.classList.remove('open');
      }
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => {
      mobileNav.classList.remove('open');
      mobileNav.querySelectorAll('.gd-mnav__panel--sub.open').forEach((p) => p.classList.remove('open'));
      toggle.setAttribute('aria-expanded', 'false');
      if (mainContent) mainContent.removeAttribute('inert');
      toggle.focus();
    });
  }
  // Escape key closes mobile nav
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('open')) {
      mobileNav.classList.remove('open');
      if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
      if (mainContent) mainContent.removeAttribute('inert');
    }
  });

  // ── Desktop dropdowns (Clubs, Brands) ────────────────────
  // Hover is handled in CSS. A click on the toggle pins the menu open
  // (.open) until the visitor clicks anywhere outside it, presses Escape,
  // or clicks the toggle again. Only one menu is pinned at a time.
  const dropdowns = Array.from(document.querySelectorAll('[data-gd-dropdown]'));
  function gdCloseDropdowns(except) {
    dropdowns.forEach(dd => {
      if (dd === except) return;
      dd.classList.remove('open');
      const t = dd.querySelector('.gd-nav__dropdown-toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  dropdowns.forEach(dd => {
    const btn = dd.querySelector('.gd-nav__dropdown-toggle');
    if (!btn) return;
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const open = !dd.classList.contains('open');
      gdCloseDropdowns(dd);
      dd.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // Keep aria-expanded truthful while hover-opened too
    dd.addEventListener('mouseenter', () => btn.setAttribute('aria-expanded', 'true'));
    dd.addEventListener('mouseleave', () => { if (!dd.classList.contains('open')) btn.setAttribute('aria-expanded', 'false'); });
  });
  if (dropdowns.length) {
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-gd-dropdown]')) gdCloseDropdowns(null);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') gdCloseDropdowns(null);
    });
  }

  // ── Search panel (Golf Avenue style) ─────────────────────
  // Markup in sections/header.liquid; live matches rendered by
  // sections/predictive-search.liquid through the Section Rendering API so
  // grades and discounted prices reuse the same Liquid as every card.
  // localStorage keys: gd_recent_searches (max 5 terms),
  // gd_recent_products (max 6 recently viewed, written on product pages).
  (function () {
    const panel = document.getElementById('gd-search-panel');
    const toggleBtn = document.getElementById('gd-search-toggle');
    const LS_TERMS = 'gd_recent_searches';
    const LS_PRODUCTS = 'gd_recent_products';
    function lsGet(key) { try { const v = JSON.parse(localStorage.getItem(key)); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
    function lsSet(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }

    // Record the product being viewed right now (JSON emitted by product.liquid)
    const recentEl = document.getElementById('gd-product-recent');
    if (recentEl) {
      try {
        const p = JSON.parse(recentEl.textContent);
        if (p && p.u) {
          const list = lsGet(LS_PRODUCTS).filter(x => x && x.u !== p.u);
          list.unshift(p);
          lsSet(LS_PRODUCTS, list.slice(0, 6));
        }
      } catch (e) {}
    }

    if (!panel || !toggleBtn) return;
    const backdrop = document.getElementById('gd-search-backdrop');
    const closeBtn = document.getElementById('gd-search-close');
    const form = document.getElementById('gd-search-form');
    const input = document.getElementById('gd-qs-input');
    const clearBtn = document.getElementById('gd-qs-clear');
    const results = document.getElementById('gd-qs-results');
    const status = document.getElementById('gd-qs-status');
    const footer = document.getElementById('gd-qs-footer');
    const allLink = document.getElementById('gd-qs-all');
    const keepSec = document.getElementById('gd-qs-keep');
    const keepList = document.getElementById('gd-qs-keep-list');
    const recentSec = document.getElementById('gd-qs-recent');
    const recentList = document.getElementById('gd-qs-recent-list');
    const clearHistoryBtn = document.getElementById('gd-qs-clear-history');
    const searchUrl = panel.dataset.searchUrl || '/search';
    const predictiveUrl = panel.dataset.predictiveUrl || '/search/suggest';
    const HINT = '<div class="gd-qs__hint">Type something to find product matches</div>';

    function esc(s) {
      return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }
    // Storage is the only untrusted input here, so both sinks are gated.
    // Links are same-origin paths ("/products/..."), images are Shopify CDN
    // URLs which image_url emits protocol-relative ("//host/cdn/shop/...").
    // Anything else, including a javascript: scheme, is dropped.
    function safeUrl(u) {
      return (typeof u === 'string' && /^\/(?!\/)/.test(u)) ? esc(u) : '#';
    }
    function safeImg(u) {
      if (typeof u !== 'string') return '';
      return /^(\/\/|https:\/\/)[^/]*\/cdn\/shop\//.test(u) || /^\/(?!\/)/.test(u) ? esc(u) : '';
    }
    const PLACEHOLDER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 21h12"/><path d="M12 21V4"/><path d="M12 4l7 3-7 3"/></svg>';

    function renderSaved() {
      const here = location.pathname;
      const keep = lsGet(LS_PRODUCTS).filter(p => p && typeof p.u === 'string' && p.u.split('?')[0] !== here);
      if (keep.length && keepList) {
        keepList.innerHTML = keep.slice(0, 4).map(p => {
          // p.a is false only when the club was already sold when it was viewed.
          // Match the Sold out badge the live results use rather than implying
          // it is still buyable.
          const sold = p.a === false;
          const badge = sold
            ? '<span class="gd-qs__cond gd-qs__cond--sold">Sold out</span>'
            : (p.c ? '<span class="gd-qs__cond' + (p.c === 'Brand New' ? ' gd-qs__cond--new' : '') + '">' + esc(p.c) + '</span>' : '');
          return '<li><a href="' + safeUrl(p.u) + '" class="gd-qs__item">' +
            '<span class="gd-qs__thumb">' + (safeImg(p.i) ? '<img src="' + safeImg(p.i) + '" width="56" height="56" alt="" loading="lazy" decoding="async">' : PLACEHOLDER) + '</span>' +
            '<span class="gd-qs__info">' +
            (p.v ? '<span class="gd-qs__vendor">' + esc(p.v) + '</span>' : '') +
            '<span class="gd-qs__name">' + esc(p.t || '') + '</span>' +
            '<span class="gd-qs__meta">' + badge +
            (p.p ? '<span class="gd-qs__price">' + esc(p.p) + '</span>' : '') +
            '</span></span></a></li>';
        }).join('');
        keepSec.hidden = false;
      } else if (keepSec) { keepSec.hidden = true; }
      const terms = lsGet(LS_TERMS);
      if (terms.length && recentList) {
        recentList.innerHTML = terms.map(t =>
          '<li><a class="gd-qs__term" href="' + searchUrl + '?q=' + encodeURIComponent(t) + '&type=product">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>' +
          esc(t) + '</a></li>'
        ).join('');
        recentSec.hidden = false;
      } else if (recentSec) { recentSec.hidden = true; }
    }

    function saveTerm(t) {
      t = (t || '').trim();
      if (!t) return;
      const list = lsGet(LS_TERMS).filter(x => typeof x === 'string' && x.toLowerCase() !== t.toLowerCase());
      list.unshift(t);
      lsSet(LS_TERMS, list.slice(0, 5));
    }

    let lastFocus = null;
    let focusTimer = null;
    // Elements this panel put inert, so closing never clears the mobile nav's.
    let inerted = [];
    function navIsOpen() { return !!(mobileNav && mobileNav.classList.contains('open')); }
    // The panel and backdrop live inside div#shopify-section-header, so inerting
    // #main-content alone leaves the whole header (logo, nav, cart) reachable by
    // Tab from inside the dialog. Walk up from the panel and inert every sibling.
    function inertBackground() {
      inerted = [];
      let node = panel;
      while (node && node !== document.body) {
        const parent = node.parentElement;
        if (!parent) break;
        Array.prototype.forEach.call(parent.children, (sib) => {
          if (sib === node || sib === backdrop) return;
          if (sib.hasAttribute('inert')) return;
          sib.setAttribute('inert', '');
          inerted.push(sib);
        });
        node = parent;
      }
    }
    function releaseBackground() {
      inerted.forEach((el) => el.removeAttribute('inert'));
      inerted = [];
    }
    function openPanel() {
      lastFocus = document.activeElement;
      renderSaved();
      panel.classList.add('open');
      backdrop.classList.add('open');
      document.documentElement.classList.add('gd-noscroll');
      toggleBtn.setAttribute('aria-expanded', 'true');
      inertBackground();
      clearTimeout(focusTimer);
      focusTimer = setTimeout(() => {
        if (panel.classList.contains('open')) input.focus();
      }, 80);
    }
    function closePanel() {
      clearTimeout(focusTimer);
      panel.classList.remove('open');
      backdrop.classList.remove('open');
      toggleBtn.setAttribute('aria-expanded', 'false');
      releaseBackground();
      // The mobile nav is also full screen and also locks scrolling. Only give
      // the page back if it is not the one still holding the visitor.
      if (!navIsOpen()) document.documentElement.classList.remove('gd-noscroll');
      // Never hand focus back into the panel we just hid.
      if (lastFocus && lastFocus.focus && lastFocus.isConnected && !panel.contains(lastFocus)) lastFocus.focus();
      else toggleBtn.focus();
    }

    toggleBtn.addEventListener('click', openPanel);
    closeBtn.addEventListener('click', closePanel);
    backdrop.addEventListener('click', closePanel);
    document.addEventListener('keydown', (e) => {
      // Capture phase so the panel wins over the mobile nav's Escape handler and
      // one press does not dismiss both.
      if (e.key === 'Escape' && panel.classList.contains('open')) {
        e.stopPropagation();
        closePanel();
      }
    }, true);
    // Keep Tab inside the open panel
    panel.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const focusables = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])'))
        .filter(el => el.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    let debounceTimer = null;
    let controller = null;
    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearBtn.hidden = q.length === 0;
      panel.classList.toggle('searching', q.length >= 2);
      clearTimeout(debounceTimer);
      if (q.length < 2) {
        if (controller) controller.abort();
        results.classList.remove('is-loading');
        setResults(HINT);
        setStatus('');
        footer.hidden = true;
        return;
      }
      // The gold CTA stays visible while the next response is in flight, so keep
      // it pointed at what is in the field rather than the last completed query.
      allLink.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
      debounceTimer = setTimeout(() => fetchMatches(q), 220);
    });
    clearBtn.addEventListener('click', () => {
      input.value = '';
      clearBtn.hidden = true;
      panel.classList.remove('searching');
      clearTimeout(debounceTimer);
      if (controller) controller.abort();
      results.classList.remove('is-loading');
      setResults(HINT);
      setStatus('');
      footer.hidden = true;
      input.focus();
    });

    // Replacing the results markup destroys whatever the visitor had focused
    // inside it, which drops focus onto <body> and takes the Tab trap with it.
    // Put focus back on the input whenever that would have happened.
    function replaceResults(fn) {
      const hadFocus = results.contains(document.activeElement);
      fn();
      if (hadFocus && !results.contains(document.activeElement)) input.focus();
    }
    function setResults(html) { replaceResults(() => { results.innerHTML = html; }); }
    function setStatus(msg) { if (status) status.textContent = msg; }

    function fetchMatches(q) {
      if (controller) controller.abort();
      const mine = new AbortController();
      controller = mine;
      results.classList.add('is-loading');
      setStatus('Searching');
      const url = predictiveUrl + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag' +
        '&section_id=predictive-search';
      fetch(url, { signal: mine.signal })
        .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(html => {
          if (input.value.trim() !== q) return;
          const out = new DOMParser().parseFromString(html, 'text/html').getElementById('gd-qs-output');
          if (!out) { setResults(HINT); setStatus(''); footer.hidden = true; return; }
          const n = parseInt(out.dataset.count || '0', 10);
          replaceResults(() => { results.innerHTML = ''; results.appendChild(out); });
          if (n > 0) {
            allLink.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
            footer.hidden = false;
            setStatus(n === 1 ? '1 match' : n + ' matches');
          } else {
            footer.hidden = true;
            setStatus('No matches');
          }
        })
        .catch(err => {
          if (err.name === 'AbortError') return;
          setResults('<div class="gd-qs__hint">Search is not responding right now. <a href="' + searchUrl + '?q=' + encodeURIComponent(q) + '&type=product">See full results</a></div>');
          setStatus('Search unavailable');
          footer.hidden = true;
        })
        // Only the request that is still the current one may clear the dimmer,
        // otherwise an aborted request leaves the panel greyed out for good.
        .finally(() => { if (controller === mine) results.classList.remove('is-loading'); });
    }

    form.addEventListener('submit', (e) => {
      const q = input.value.trim();
      if (!q) { e.preventDefault(); return; }
      saveTerm(q);
    });
    // A tap on a match or on View all counts as a search worth remembering
    results.addEventListener('click', (e) => {
      if (e.target.closest('a')) saveTerm(input.value);
    });
    if (allLink) allLink.addEventListener('click', () => saveTerm(input.value));
    if (clearHistoryBtn) {
      clearHistoryBtn.addEventListener('click', () => {
        lsSet(LS_TERMS, []);
        renderSaved();
        input.focus();
      });
    }
  })();

  // ── Scroll-triggered animations ──────────────────────────
  const animEls = document.querySelectorAll('.gd-animate');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      // Stagger only the elements revealing together in this batch, in DOM order,
      // so grids and rows cascade naturally instead of popping all at once.
      const showing = entries.filter(e => e.isIntersecting);
      showing.forEach((entry, i) => {
        setTimeout(() => entry.target.classList.add('visible'), Math.min(i, 6) * 90);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    animEls.forEach(el => observer.observe(el));
  } else {
    animEls.forEach(el => el.classList.add('visible'));
  }

  // ── Count-up numbers (stat figures) ──────────────────────
  const prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function gdCountUp(el) {
    const to = parseFloat(el.dataset.countTo);
    if (isNaN(to)) return;
    const prefix = el.dataset.countPrefix || '';
    const suffix = el.dataset.countSuffix || '';
    const decimals = parseInt(el.dataset.countDecimals || '0', 10);
    const fmt = (v) => prefix + v.toFixed(decimals) + suffix;
    if (prefersReduced) { el.textContent = fmt(to); return; }
    const duration = 1200;
    const start = performance.now();
    function tick(now) {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      el.textContent = fmt(to * eased);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  const countEls = document.querySelectorAll('[data-count-to]');
  if (countEls.length) {
    if ('IntersectionObserver' in window) {
      const countObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            gdCountUp(entry.target);
            countObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });
      countEls.forEach(el => countObserver.observe(el));
    } else {
      countEls.forEach(gdCountUp);
    }
  }

  // ── Parallax drift on atmosphere backgrounds ─────────────
  // Drives the --gd-parallax CSS var on .gd-atmos so its cinematic
  // background layer glides slightly against the content. rAF-batched,
  // only processes elements currently in view, and disabled for
  // reduced-motion / very small screens (where it adds jank, not depth).
  const parallaxEls = Array.from(document.querySelectorAll('.gd-atmos[data-parallax]'));
  const smallScreen = window.matchMedia('(max-width: 640px)').matches;
  if (parallaxEls.length && !prefersReduced && !smallScreen) {
    let visible = new Set();
    if ('IntersectionObserver' in window) {
      const pObs = new IntersectionObserver((entries) => {
        entries.forEach(e => e.isIntersecting ? visible.add(e.target) : visible.delete(e.target));
      }, { threshold: 0 });
      parallaxEls.forEach(el => pObs.observe(el));
    } else {
      visible = new Set(parallaxEls);
    }
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      visible.forEach(el => {
        const rect = el.getBoundingClientRect();
        // -1 (section below view) → 1 (section above view)
        const progress = (rect.top + rect.height / 2 - vh / 2) / (vh + rect.height / 2);
        const strength = parseFloat(el.dataset.parallax) || 40;
        el.style.setProperty('--gd-parallax', (progress * strength).toFixed(1) + 'px');
      });
      ticking = false;
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  // ── Pointer-reactive sheen on interactive glass panels ───
  if (!prefersReduced && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.gd-glass--interactive').forEach(card => {
      card.addEventListener('pointermove', (e) => {
        const r = card.getBoundingClientRect();
        card.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
        card.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }

  // ── Product page functions defined in product.liquid ────
  // gdQty, gdSelectVariant, gdTab, gdShowImg are defined inline on the
  // product page where they reference product-specific elements.

  // ── Trade-in calculator ──────────────────────────────────

  const brandSelect   = document.getElementById('gd-ti-brand');
  const typeSelect    = document.getElementById('gd-ti-type');
  const modelSelect   = document.getElementById('gd-ti-model');
  const resultBox     = document.getElementById('gd-ti-result');

  let clubsData = [];

  if (brandSelect) {
    // Load data from inline JSON if present
    const dataEl = document.getElementById('gd-clubs-json');
    if (dataEl) {
      try {
        clubsData = JSON.parse(dataEl.textContent);
        if (clubsData && clubsData.length) {
          initCalculator();
        } else {
          showCalculatorError('No club data available right now.');
        }
      } catch(e) {
        showCalculatorError('Could not load club data. Refresh to try again.');
      }
    }
  }

  function showCalculatorError(msg) {
    if (brandSelect) {
      brandSelect.innerHTML = '<option value="">' + msg + '</option>';
      brandSelect.disabled = true;
    }
    if (typeSelect)  { typeSelect.disabled  = true; }
    if (modelSelect) { modelSelect.disabled = true; }
    if (resultBox) {
      resultBox.classList.remove('hidden');
      resultBox.innerHTML = '<div class="gd-ti-error" style="padding:14px 16px;background:#fef3f3;border:1px solid #f1c4c4;color:#a03b3b;border-radius:4px;font-size:13px;line-height:1.5">' + msg + ' If this keeps happening, <a href="mailto:info@golfdepotusa.com" style="color:inherit;text-decoration:underline">email us</a> and we will quote your clubs by hand.</div>';
    }
  }

  function initCalculator() {
    // Populate brands
    const brands = [...new Set(clubsData.map(c => c.Brand).filter(Boolean))].sort();
    if (brandSelect) {
      brandSelect.innerHTML = '<option value="">Select Brand</option>';
      brands.forEach(b => {
        const opt = document.createElement('option');
        opt.value = b; opt.textContent = b;
        brandSelect.appendChild(opt);
      });
      brandSelect.addEventListener('change', onBrandChange);
    }
    if (typeSelect) typeSelect.addEventListener('change', onTypeChange);
    if (modelSelect) modelSelect.addEventListener('change', onModelChange);
  }

  function onBrandChange() {
    const brand = brandSelect.value;
    if (!brand) return resetAfter('type');
    const types = [...new Set(
      clubsData.filter(c => c.Brand === brand).map(c => c.Type).filter(Boolean)
    )].sort();
    typeSelect.innerHTML = '<option value="">Select Type</option>';
    types.forEach(t => {
      const opt = document.createElement('option');
      opt.value = t; opt.textContent = t;
      typeSelect.appendChild(opt);
    });
    typeSelect.disabled = false;
    resetAfter('model');
  }

  function onTypeChange() {
    const brand = brandSelect.value;
    const type  = typeSelect.value;
    if (!type) return resetAfter('model');
    const models = [...new Set(
      clubsData.filter(c => c.Brand === brand && c.Type === type).map(c => c.Model).filter(Boolean)
    )].sort();
    modelSelect.innerHTML = '<option value="">Select Model</option>';
    models.forEach(m => {
      const opt = document.createElement('option');
      opt.value = m; opt.textContent = m;
      modelSelect.appendChild(opt);
    });
    modelSelect.disabled = false;
    if (resultBox) resultBox.classList.add('hidden');
  }

  function onModelChange() {
    const brand = brandSelect.value;
    const type  = typeSelect.value;
    const model = modelSelect.value;
    if (!model) { if (resultBox) resultBox.classList.add('hidden'); return; }
    const match = clubsData.find(c => c.Brand === brand && c.Type === type && c.Model === model);
    if (match && resultBox) {
      const cash   = match.Price || 0;
      const credit = (cash * 1.2).toFixed(2);
      document.getElementById('gd-ti-cash').textContent   = '$' + cash.toFixed(2);
      document.getElementById('gd-ti-credit').textContent = '$' + credit;
      resultBox.classList.remove('hidden');
      resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function resetAfter(level) {
    if (level === 'type') {
      if (typeSelect)  { typeSelect.innerHTML  = '<option value="">Select Type</option>';  typeSelect.disabled  = true; }
    }
    if (level === 'type' || level === 'model') {
      if (modelSelect) { modelSelect.innerHTML = '<option value="">Select Model</option>'; modelSelect.disabled = true; }
    }
    if (resultBox) resultBox.classList.add('hidden');
  }

  // ── Collection filter ────────────────────────────────────
  const filterBtns = document.querySelectorAll('.gd-filter-btn');
  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // ── ATC handled in product.liquid inline script ─────────

});
